import { SortingState } from '@tanstack/react-table';
import { AdminAgentsFilterDto, AgentDealStatus } from '@repo/common-types';

export interface AgentsFilterLocal extends Omit<AdminAgentsFilterDto, 'isRegionalManager'> {
  isRegionalManager?: boolean | '';
}

export interface AgentsQueryState {
  skip: number;
  take: number;
  sorting: SortingState;
  filter?: AgentsFilterLocal;
}

export const initialState: AgentsQueryState = {
  skip: 0,
  take: 500,
  sorting: [],
  filter: {
    search: '',
    dealType: undefined,
    userAgreementType: '',
    isRegionalManager: '',
    dealStatus: [AgentDealStatus.ACTIVE, AgentDealStatus.UPCOMING],
    alias: '',
    email: '',
  },
};

export type AgentsQueryAction =
  | { type: 'SET_PAGINATION'; payload: { skip: number; take: number } }
  | { type: 'SET_SORTING'; payload: SortingState }
  | { type: 'SET_SEARCH'; payload: string }
  | { type: 'SET_FILTERS'; payload: AgentsFilterLocal }
  | { type: 'RESET_FILTERS' };

export const queryReducer = (state: AgentsQueryState, action: AgentsQueryAction): AgentsQueryState => {
  switch (action.type) {
    case 'SET_PAGINATION':
      return {
        ...state,
        skip: action.payload.skip,
        take: action.payload.take,
      };
    case 'SET_SORTING':
      return {
        ...state,
        sorting: action.payload,
      };
    case 'SET_SEARCH':
      return {
        ...state,
        skip: 0, // Reset to first page when searching
        filter: {
          ...state.filter,
          search: action.payload,
        },
      };
    case 'SET_FILTERS':
      return {
        ...state,
        skip: 0, // Reset to first page when filtering
        filter: {
          ...state.filter,
          ...action.payload,
        },
      };
    case 'RESET_FILTERS':
      return {
        ...state,
        skip: 0,
        filter: initialState.filter,
      };
    default:
      return state;
  }
};
